import { jsx as _jsx } from "react/jsx-runtime";
import { Form } from "@brushfire/ui";
import createAutoCorrectedDatePipe from "text-mask-addons/dist/createAutoCorrectedDatePipe";
var pipe = createAutoCorrectedDatePipe("mm/yy", { minYear: new Date().getFullYear() });
var MaskedCardExpInput = function (_a) {
    var label = _a.label, hiddenLabel = _a.hiddenLabel, name = _a.name, placeholder = _a.placeholder, className = _a.className, id = _a.id, autoComplete = _a.autoComplete, required = _a.required;
    return (_jsx(Form.Field, { component: Form.Input.MaskedTextInput, mask: [/\d/, /\d/, "/", /\d/, /\d/], pipe: pipe, className: className, alwaysShowMask: true, label: label, hiddenLabel: hiddenLabel, name: name, id: id, placeholder: placeholder, autoComplete: autoComplete, isFieldRequired: required }));
};
export default MaskedCardExpInput;
